export const SelectTabViewModel = ({ setValue }) => {
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };
  return {
    handleChange,
  };
};
